export enum Field {
  NAME = "name",
  ACCOUNT_NUMBER = "accountNumber",
  START_DATE = "startDate",
  END_DATE = "endDate",
  LINK_TO_POLICY = "linkToPolicy",
}
